import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import '../../css/app.css';
import CartBox from "./CartBox.jsx";

const rootUrl = process.env.NODE_ENV === 'development' ? 'https://dev-thomas.tom-it.nl' : 'https://app.crewcart.io';

// Check for specific localStorage items before initializing Sentry
const crewCartUserId = localStorage.getItem('crewCartUserId');
const crewCartToken = localStorage.getItem('crewCartToken');
const shouldEnableReplay = !!(crewCartUserId && crewCartToken);

Sentry.init({
    dsn: "https://27bcfd1af1e5c1229644bbd8764ebba0@app.crewcart.io/api/sentry-proxy/4508768703676496",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            // Configure specific masking rules
            mask: [
                // Only mask input elements of type "email"
                '[type="email"]'
            ],
            // Set replay to start automatically based on your condition
            startAutomatically: shouldEnableReplay
        }),
    ],
    tunnel: "/api/sentry-proxy",
    allowUrls: [
        window.location.origin,
        'tom-it.nl',
        'dev-thomas.tom-it.nl',
        'app.crewcart.io',
        'inventory-information-dev.myshopify.com'
    ],
    beforeSend(event, hint) {
        const exception = hint.originalException;
        if (exception && exception.message === "This is your first error!") {
            event.fingerprint = ['test-error-' + Date.now()];
        }
        return event;
    },
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: shouldEnableReplay ? 1 :0,
    replaysOnErrorSampleRate: 1.0,
});

// Add a log to confirm if replay is enabled
if (shouldEnableReplay) {
    console.log('Sentry replay recording enabled based on user credentials');
}

if (document.getElementById('app')) {
    const shopDomain = document.querySelector('meta[name="shop"]')?.getAttribute('content');

    ReactDOM.createRoot(document.getElementById('app')).render(
        <React.StrictMode>
            <CartBox rootUrl={rootUrl} shop={shopDomain} />
        </React.StrictMode>
    );
}
